<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true">
    <template v-slot:body>
      <div class="content">
        <el-row type="flex" justify="center">
          <el-col>
            <div class="list" v-if="page === 'list'">
              <h4 id="leave-modal-title">
                {{ $t($i18nLabelsHelper(currentOrganizationType, `assignments.modals_delete_title`)) }}
              </h4>
              <p id="leave-modal-desc">
                {{ $t($i18nLabelsHelper(currentOrganizationType, `assignments.modals_delete_decs`)) }}
              </p>
            </div>
            <div class="detail" v-else>
              <h4 id="leave-modal-title">
                {{ $t($i18nLabelsHelper(currentOrganizationType, `assignments.modals_delete_detail_title`)) }}
              </h4>
              <p id="leave-modal-desc">
                {{ $t($i18nLabelsHelper(currentOrganizationType, `assignments.modals_delete_detail_decs`)) }}
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
    <template v-slot:footer>
      <primary-button class="confirm-delete" ref="" @click.native="handleLeave">
        {{ $t('common.delete') }}
      </primary-button>
      <tertiary-button class="confirm-cancel" @click.native="$emit('closed')">
        {{ $t('common.cancel') }}
      </tertiary-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import PrimaryButton from '@/components/common/buttons/PrimaryButton';
import TertiaryButton from '@/components/common/buttons/TertiaryButton';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    page: {
      type: String,
      default: 'detail',
    },
  },
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton,
  },
  computed: {
    getTitle() {
      return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, 'modals.delete.title'), {
        numberOfClasses: this.numberOfSelectedClasses,
      });
    },
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType',
    }),
  },
  methods: {
    handleLeave() {
      this.$emit('closed');
      this.$emit('delete');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.content {
  .list {
    max-width: 313px;
  }
  .detail {
    max-width: 300px;
  }
}

#leave-modal-title {
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  text-align: center;
  color: $black;
  margin: 0 auto;
}

#leave-modal-desc {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: $black;
  margin: 15px auto 0 auto;
}

.elsa-button.confirm-delete,
.elsa-button.confirm-delete:hover {
  background: $orange;
  border-radius: 8px;
}

.elsa-button.confirm-cancel,
.elsa-button.confirm-cancel:hover {
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
}

::v-deep {
  .el-dialog.elsa-modal {
    .el-dialog__header,
    .el-dialog__body {
      background-color: white;
      align-items: center;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}
</style>
